<template>
  <div
    id="app"
    class="antialiased text-gray-800"
  >
    <div
      class="min-h-screen text-white"
      style="
      background-image: linear-gradient(rgba(62,76,89,0.7),rgba(62, 76, 89, 0.4)),url(/img/bg.jpg);
      background-size: cover;
      background-position: center;
      font-family: 'Raleway', sans-serif;"
    >
      <div class="xl:p-8 md:p-4 p-2 absolute top-0 left-0">
        <a
          target="_blank"
          :href="homeUrl"
        >
          <img
            :class="$isNine ? 'xl:h-24 md:h-20 h-16' : 'xl:h-12 md:h-10 h-8'"
            :src="logoUrl"
          >
        </a>
      </div>

      <div
        id="referralSection"
        class="xl:pt-20 lg:pt-12 md:pt-10 sm:pt-8 pt-8"
        style="opacity: 1; transition: opacity 2s; -webkit-transition: opacity 2s;"
      >
        <div class="text-center xl:p-4 p-2 xl:text-2xl md:text-lg text-sm">
          <div
            v-if="referrersName != null"
            class="inline-block"
          >
            {{ referrersName }}'s referral page
          </div>
        </div>

        <div
          class="text-brand-500 mr-auto ml-auto text-center xl:p-4 p-2 pb-2 xl:max-w-5xl
        md:max-w-3xl xl:text-3xl md:text-2xl"
        >
          {{ referralHeadline }}
        </div>

        <div
          v-if="referrersName != null"
          class="text-center p-2 xl:text-xl md:text-lg text-sm"
        >
          Plus recieve {{ referralPayoutAmount }} free points for both you and {{ referrersName }},
          worth up to <div
            v-if="referralPayoutAmount != 20"
            class="inline"
          >
            5
          </div><div
            v-if="referralPayoutAmount == 20"
            class="inline"
          >
            10
          </div> free rounds each!
        </div>

        <div
          v-if="referrersName == null"
          class="text-center p-2 xl:text-xl md:text-lg text-sm"
        >
          If you know someone that is a {{ $isNine ? 'IX' : 'PlayMoreGolf' }} member, ask them for
          their unique referral page. You will both be rewarded {{ referralPayoutAmount }} free points!
        </div>

        <div
          v-show="historicBookings > 0 || upcomingBookings > 0"
          class="text-center p-2 xl:text-lg md:text-lg text-sm"
        >
          <div class="text-lg font-semibold">
            You Have Bookings Waiting!
          </div>
          <div v-if="upcomingBookings > 0 && historicBookings == 0">
            <i class="far fa-calendar-star" /> Create an account to manage your upcoming booking with {{ referrersName }}
          </div>
          <div v-else-if="upcomingBookings == 0 && historicBookings > 0">
            <i class="far fa-calendar-star" /> Create an account to view your past bookings with {{ referrersName }}, and start booking more rounds
          </div>
          <div v-else>
            <i class="far fa-calendar-star" /> Create an account to manage your upcoming and past bookings with {{ referrersName }}
          </div>
        </div>

        <div class="ml-auto mr-auto xl:w-2/6 md:w-6/12 sm:w-9/12 xl:p-8 p-3 pt-2 z-20">
          <div class="bg-white rounded shadow-lg border-t-4 border-brand-500">
            <div v-if="!accountCreated">
              <div class="text-gray-800 xl:p-6 xl:pb-4 xl:pt-4 lg:p-6 md:p-5 p-5">
                <div class="text-center xl:text-xl text-lg">
                  Let's get you started
                </div>
                <div
                  v-if="referrersName != null"
                  class="text-center text-gray-600 xl:text-md text-sm"
                >
                  Tell us a few details and we'll create you a {{ $isNine ? 'IX' : 'PlayMoreGolf' }} account. You'll be able to look around, play golf with {{ referrersName }} as a guest and view our network. There's no commitment and no card details necessary.
                </div>
                <div
                  v-else
                  class="text-center text-gray-600 xl:text-md text-sm"
                >
                  Tell us a few details and we'll create you a {{ $isNine ? 'IX' : 'PlayMoreGolf' }} account. You'll be able to look around and view our network. There's no commitment and no card details necessary.
                </div>

                <div class="flex">
                  <div class="flex sm:mt-4 mt-2 w-full min-w-full">
                    <input
                      v-model="forename"
                      class="p-2 w-1/2 text-sm rounded-sm shadow-md bg-gray-100"
                      placeholder="Forename"
                      type="text"
                      style="border-width: thin; font-family: 'Roboto', sans-serif;"
                    >
                    <input
                      v-model="surname"
                      class="sm:ml-4 ml-2 p-2 w-1/2 text-sm rounded-sm shadow-md bg-gray-100"
                      placeholder="Surname"
                      type="text"
                      style="border-width: thin; font-family: 'Roboto', sans-serif;"
                    >
                  </div>
                </div>

                <div class="sm:mt-4 mt-2 w-full min-w-full rounded-sm">
                  <input
                    v-model="email"
                    class="p-2 w-full text-sm shadow-md bg-gray-100"
                    placeholder="Email"
                    type="text"
                    style="border-width: thin; font-family: 'Roboto', sans-serif;"
                  >
                </div>

                <!--v-if="referrersName == null"-->
                <div

                  class="sm:mt-4 mt-2 w-full min-w-full rounded-sm"
                >
                  <input
                    v-model="number"
                    class="p-2 w-full text-sm shadow-md bg-gray-100"
                    placeholder="Phone number"
                    type="text"
                    style="border-width: thin; font-family: 'Roboto', sans-serif;"
                  >
                </div>

                <div class="flex">
                  <div class="flex sm:mt-4 mt-2 w-full min-w-full rounded-sm">
                    <input
                      v-model="password"
                      class="p-2 w-1/2 text-sm shadow-md bg-gray-100"
                      type="password"
                      placeholder="Password"
                      style="border-width: thin; font-family: 'Roboto', sans-serif;"
                    >
                    <input
                      v-model="confirmPassword"
                      class="sm:ml-4 ml-2 p-2 w-1/2 text-sm  shadow-md bg-gray-100"
                      type="password"
                      placeholder="Confirm Password"
                      style="border-width: thin; font-family: 'Roboto', sans-serif;"
                    >
                  </div>
                </div>

                <div
                  v-if="referrersName != null"
                  class="mt-4 ml-1 md:text-base text-sm"
                >
                  <div class="inline">
                    <input
                      id="cbx"
                      v-model="addAsBuddy"
                      class="inp-cbx"
                      style="display: none;"
                      type="checkbox"
                      name="addAsBuddy"
                    > <label
                      class="cbx"
                      for="cbx"
                    ><span>
                      <svg
                        width="12px"
                        height="10px"
                        viewBox="0 0 12 10"
                      >
                        <polyline points="1.5 6 4.5 9 10.5 1" />
                      </svg></span><span class="sm:text-base text-xs">
                      Send {{ referrersName }} a buddy request</span></label>
                  </div> <a href="#/"><div
                    class="tooltip inline-block lg:pl-0 pl-4 relative text-tertiary-500
                     ml-2 hover:underline sm:text-base text-xs"
                  > What does this mean?<span class="tooltiptext sm:text-base text-xs">
                    Buddying another member allows you to add each other
                    to bookings. This means they can use your points without confirmation.
                    Only buddy people you know
                    and trust.</span></div></a>
                </div>

                <div
                  v-if="referrersName != null"
                  class="mt-1 ml-1 md:text-base text-sm"
                >
                  <div class="inline">
                    <input
                      id="cbx2"
                      v-model="useReferrersHomeClub"
                      type="checkbox"
                      style="display: none;"
                      class="inp-cbx2"
                      name="useReferrersHomeClub"
                    > <label
                      class="cbx2 inline"
                      for="cbx2"
                    ><span>
                      <svg
                        width="12px"
                        height="10px"
                        viewBox="0 0 12 10"
                      >
                        <polyline points="1.5 6 4.5 9 10.5 1" />
                      </svg></span><span class="inline sm:text-base text-xs">
                      Set {{ referrersHomeClub }} as my home club</span></label>
                  </div>
                </div>

                <p
                  v-if="errors.length"
                  class="text-red-800 mt-2"
                >
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li
                      v-for="error in errors"
                      :key="error"
                      class="text-red-800"
                    >
                      {{ error }}
                    </li>
                  </ul>
                </p>

                <a href="#/">
                  <div
                    :class="(loading)?'bg-tertiary-900 cursor-wait':
                      'bg-tertiary-500 hover:bg-tertiary-800'"
                    class="text-center p-2 mt-2 text-white
                    rounded tracking-wider font-bold hover:-translate-y-1"
                    @click="checkIfUsernameExists()"
                  >
                    Discover {{ $isNine ? 'IX' : 'PlayMoreGolf' }}
                  </div>
                </a>
              </div>
            </div>

            <div v-if="accountCreated">
              <div class="text-gray-800 xl:p-6 xl:pb-4 xl:pt-4 lg:p-6 md:p-5 p-5">
                <div class="text-center xl:text-xl text-lg">
                  Nearly there
                </div>
                <div class="xl:text-base text-sm pt-2">
                  We just need your postcode.
                  This will allow us to find the clubs that are near you.
                </div>

                <div class="mt-4 w-full min-w-full rounded-sm">
                  <input
                    v-model="postcode"
                    class="p-2 w-full text-sm inline-block "
                    placeholder="Postcode"
                    style="border-width: thin; font-family: 'Roboto',
                    sans-serif; width: 60%; min-width: 60%; padding-top: 9px;"
                  >
                  <a href="#/">
                    <div
                      :class="(loading)?'bg-tertiary-900 cursor-wait':
                        'bg-tertiary-500 hover:bg-tertiary-800'"
                      class="inline-block p-2 text-center text-white
                    rounded-r tracking-wider font-bold md:text-base text-sm"
                      style=" width: 40%; min-width: 40%;"
                      @click="validatePostcode()"
                    >
                      Continue
                    </div>
                  </a>
                </div>

                <div class="xl:text-base text-sm mr-auto ml-auto text-center p-2">
                  or
                </div>

                <a href="#/"><div
                  :class="(loading)?'bg-orange-300 cursor-wait':'bg-orange-600'"
                  class="min-w-full w-full p-2 text-white font-semibold
                  text-center tracking-wider hover:-translate-y-1"
                  @click="getLocation"
                >
                  <i class="fas fa-map-marker-alt mr-1" /> Use my location
                </div></a>

                <p
                  v-if="errors.length"
                  class="text-red-800 mt-2"
                >
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li
                      v-for="error in errors"
                      :key="error"
                      class="text-red-800"
                    >
                      {{ error }}
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  referrersDetails, register, login, UsernameExists, referralPayoutAmount, referrerGhostAccountDetails,
} from '@/app/shared/services';
import { RegistrationDetails } from '../../shared/services/accountService/classes/registrationDetails';
import { LoginDetails } from '../../shared/services/accountService/classes/loginDetails';

export default {
  name: 'App',
  data() {
    return {
      accountCreated: false,
      referralShareCode: this.$route.params.id,
      ghostUId: this.$route.params.ghostuid,
      referrersName: null,
      referrersHomeClub: null,
      errors: [],
      forename: null,
      surname: null,
      email: null,
      number: null,
      password: null,
      confirmPassword: null,
      postcode: null,
      gettingLocation: false,
      addAsBuddy: false,
      useReferrersHomeClub: false,
      loading: false,
      upcomingBookings: 0,
      historicBookings: 0,
      referralPayoutAmount: 10,
    };
  },

  computed: {
    homeUrl() {
      return this.$isNine
        ? 'https://www.ix.golf/'
        : 'https://www.playmore.golf/';
    },
    logoUrl() {
      return this.$isNine
        ? '/img/IX-Logo.png'
        : '/img/PMG.png';
    },
    referralHeadline() {
      return this.$isNine
        ? 'Flexible membership for premier golf club\'s.'
        : 'Great member benefits, an official handicap and the freedom to play on over 200 courses at no extra cost';
    },
  },
  mounted() {
    this.referrersDetails();
    this.getPayoutAmount();
    document.addEventListener('keydown', this.enter, false);
  },

  methods: {
    enter(e) {
      const { keyCode } = e;
      if (keyCode === 13) {
        if (this.accountCreated === false) {
          this.validateAccount();
        } else {
          this.validatePostcode();
        }
      }
    },

    getPayoutAmount() {
      referralPayoutAmount().then((result) => {
        if (result.status == 200 && result.data.ReferralPayoutAmount > 10) {
          this.referralPayoutAmount = result.data.ReferralPayoutAmount;
        }
      });
    },

    createAccount() {
      this.loading = true;
      const registrationDetails = new RegistrationDetails(this.referralShareCode,
        this.forename, this.surname, this.number, this.email, this.password, this.postcode,
        this.addAsBuddy, this.useReferrersHomeClub, this.ghostUId);

      register(registrationDetails).then((result) => {
        if (result.success) {
          try {
            const _hsq = window._hsq = window._hsq || [];
            _hsq.push(['identify', {
              email: this.email,
            }]);
          } catch (err) {
            console.lo(err);
          }
          this.loginUser();
        }
      });
    },

    loginUser() {
      login(new LoginDetails(this.email, this.password)).then((result) => {
        console.log('Executed');
        if (result.ValidCredentials) {
          const url = this.$isNine
            ? 'https://members.ix.golf/'
            : 'https://members.playmore.golf/';
          window.location.replace(url);
        }
      });
    },

    checkIfUsernameExists() {
      this.loading = true;
      UsernameExists(this.email).then((result) => {
        this.validateAccount(result.data.Exists);
      });
    },

    getLocation() {
      this.loading = true;
      if (!('geolocation' in navigator)) {
        this.postcode = 'Geolocation is not available.';
        return;
      }

      this.gettingLocation = true;
      navigator.geolocation.getCurrentPosition((pos) => {
        this.gettingLocation = false;
        const vm = this;
        const result = (new google.maps.Geocoder()).geocode({ location: { lat: pos.coords.latitude, lng: pos.coords.longitude } }, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              const postcode = results[0].address_components.filter((res, i) => res.types[0] === 'postal_code')[0].long_name;

              vm.postcode = postcode;
              vm.createAccount();
            }
          }
        });
      }, (err) => {
        this.gettingLocation = false;
        this.loading = false;
      });
    },

    referrersDetails() {
      const value = this.referralShareCode;

      const showSection = () => {
        const el = document.getElementById('referralSection');
        if (el) {
          el.style.opacity = '1';
          el.style.display = 'block';
        }
      };

      referrersDetails(value).then((result) => {
        if (result.data != null) {
          this.referrersName = result.data.Forename;
          this.referrersHomeClub = result.data.HomeClub;
          this.addAsBuddy = true;
          this.useReferrersHomeClub = true;
        }
      })
        .catch((err) => {
          console.error('[referrersDetails] failed', err);
        })
        .finally(() => {
          showSection();
        });

      const ghost = this.ghostUId;
      if (ghost !== null) {
        const vm = this;
        referrerGhostAccountDetails(ghost).then((result) => {
          const data = result && result.data ? result.data : null;
          if (data == null) {
            return;
          }
          vm.email = data.EmailAddress;
          vm.historicBookings = data.PastBookings;
          vm.upcomingBookings = data.UpcomingBookings;
        });
      }
    },

    validateAccount(emailExists) {
      this.errors = [];

      let nameLengthCount = 0;
      if (!this.forename) {
        this.errors.push('• Forename required.');
      } else {
        nameLengthCount += this.forename.length;
      }

      if (!this.surname) {
        this.errors.push('• Surname required.');
      } else {
        nameLengthCount += this.surname.length;
      }

      if (nameLengthCount > 80) {
        this.errors.push('• Forename and lastname must be less than 80 characters.');
      }

      if (!this.email) {
        this.errors.push('• Email required.');
      } else if (!this.email.includes('.') || !this.email.includes('@')) {
        this.errors.push('• Valid email required.');
      }

      // if (this.referrersName == null) {
      const phoneDigits = (this.number || '').replace(/\D/g, '');
      if (phoneDigits.length < 11) {
        this.errors.push('• Valid phone number required.');
      }
      // }

      if (!this.password || !this.confirmPassword) {
        this.errors.push('• Password required.');
      } else if (this.password.length < 6) {
        this.errors.push('• Password must be at least 6 characters.');
      } else if (this.password.length > 50) {
        this.errors.push('• Password must be less than 50 characters.');
      }

      if (this.password !== this.confirmPassword) {
        this.errors.push('• Passwords do not match.');
      }

      if (emailExists) {
        this.errors.push('• This email address already has an account.');
      }

      this.loading = false;
      if (this.errors.length === 0) {
        if (this.useReferrersHomeClub) {
          this.createAccount();
        } else {
          this.accountCreated = true;
        }
      }
    },

    validatePostcode() {
      this.errors = [];

      if (!this.postcode) {
        this.errors.push('• Postcode required.');
      } else if (this.postcode.length < 5 || this.postcode.length > 8) {
        this.errors.push('• Please enter a valid postcode.');
      }

      if (this.errors.length === 0) {
        this.createAccount();
      }
    },
  },
};
</script>
